import { Input } from 'antd'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from '../..'
import { DescriptionFormItemProps } from './types'

/**
 * wraps a {@link CIMSFormItem} for `description` fields
 */
const DescriptionFormItem: React.FC<DescriptionFormItemProps> = ({
  initialValue,
  entityName,
}) => (
  <CIMSFormItem
    name="description"
    label="Description"
    help={HelpMessage.Description(entityName)}
    initialValue={initialValue}
  >
    <Input allowClear />
  </CIMSFormItem>
)

export default DescriptionFormItem
